<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
              </li>
              <li class="breadcrumb-item" aria-current="page" v-if="type==='admin'">
                <router-link :to="{path:'/admin/grupos'}">Servicios</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">{{ service.name }}
              </li>
            </ol>
          </nav>
        </div>


        <div class="col-md-12">
          <div class="jumbotron">
            <h1 class="display-4">{{ service.name }}
            </h1>
            <div>
              <p>
                <strong>Precio:</strong> {{service.price}}<br>
                <i class="fas fa-users"></i><strong> Jugadores:</strong> {{ service.players.length }}<br>
                <span v-html="service.descri"></span>
              </p>
            </div>
          </div>

        </div>


        <div class="col-md-12" style="margin-bottom: 20px">

          <h2>Jugadores</h2>

          <div class="card">
            <div class="table-responsive">
              <table class="table table-striped text-nowrap" id="table-players">
                <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Año de Nacimiento</th>
                  <th>Club</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="player in service.players">
                  <th>
                    <div class="media align-items-center">

                      <img alt="Image placeholder" :src="player.img"
                           class="avatar rounded-circle mr-3">

                      <div class="media-body">
                        <router-link :to="{path: '/jugadores/'+player.id}">
                          <span class="name mb-0 text-sm"
                                id="name-player">{{ player.apellidos | capitalizeText }}, {{ player.nombre | capitalizeText }}</span>
                        </router-link>
                      </div>
                    </div>

                  </th>

                  <td class="align-middle">
                    {{ player.year | parseDate }}
                  </td>
                  <td class="align-middle">
                    {{ player.club }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'


export default {
  data() {
    return {
      service: {},
      type: this.$store.getters.type,
    };
  },
  directives: {
    'b-tooltip': BTooltipDirective
  },
  created() {
    this.loadService();
  },
  methods: {
    loadService() {
      let vm = this;
      axios.get(this.$store.getters.apiUrl + 'services/' + this.$route.params.id, {
        params: {
          jwt: vm.$store.getters.jwt,
          season: vm.$store.getters.season
        }
      }).then(response => {
        if (response.data.response) {
          vm.service = response.data.result;
        } else {
          swal({
            title: 'Atención',
            text: response.data.message,
            confirmButtonClass: 'btn btn-info btn-fill',
            type: 'error'
          });

        }
      }).catch(e => {
        swal({
          title: 'Atención',
          text: e,
          confirmButtonClass: 'btn btn-info btn-fill',
          type: 'error'
        });

      });
    }
  }

};
</script>
<style scoped>

.container-fluid {
  margin-top: 39px;
}

.card {
  background-color: #f7fafc !important;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
  border: 1px solid rgba(0, 0, 0, .05);
  border-radius: .375rem;
}

#table-players tbody tr:hover {
  background-color: rgba(62, 92, 75, 0.3);
}

#table-players tbody tr:hover #name-player {
  text-decoration: underline;
}


</style>
